import WrapWithTheme from './src/components/wrap-with-theme'

export const wrapRootElement = WrapWithTheme